import { atomFamily, selectorFamily, useRecoilState } from "recoil";

export const getLocalStorageValue = (key: string) => {
    if (localStorage) {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }
    return null;
};

export const setLocalStorageValue = (key: string, value: string | null) => {
    if (localStorage && typeof value === "string") {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            return;
        }
    }
};

const localstorageToken = atomFamily<string | null, string>({
    key: "localstorageToken",
    default: (key) => getLocalStorageValue(key),
});

export const localstorageTokenQuery = selectorFamily<string | null, string>({
    key: "localstorageTokenQuery",
    get: (key) => ({ get }) => get(localstorageToken(key)),
    set: (key) => ({ set }, newValue) => {
        set(localstorageToken(key), newValue);
        setLocalStorageValue(key, newValue as any);
    },
});

export const useLocalStorage = <T>(key: string, defaultValue: T) => {
    const recoilState = localstorageTokenQuery(key);
    const [value, setValue] = useRecoilState(recoilState);
    return [(value ?? defaultValue) as T, setValue] as const;
};
